<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPencilAlt, faTrash, faSpinner } from '@fortawesome/free-solid-svg-icons';

import Pagination from '@/components/Pagination';
library.add( faPencilAlt, faTrash, faSpinner );

export default {
  name: 'ModuleAdministratorsList',
  components: {
    Pagination,
  },
  computed: {
    ...mapState('administrator/collection', [
      'items',
      'pagination',
      'isLoading',
    ]),
    page: {
      get() {
        return this.pagination.page;
      },
      set(page) {
        this.setPage(page);
        this.fetch(this.query);
      },
    },
    query() {
      const { query } = this.$route;
      return query.q || null;
    },
  },
  watch: {
    query: function(newQuery, oldQuery) {
      if (newQuery === oldQuery) {
        return;
      }
      this.fetch(newQuery);
    },
  },
  methods: {
    ...mapActions('administrator/collection', [
      'fetch',
    ]),
    ...mapMutations('administrator/collection', [
      'setPage',
    ]),
    ...mapActions('administrator/item', [
      'remove',
    ]),
    confirmDelete(item) {
      const fullName = `${item.first_name} ${item.last_name}`;
      this.$dialog.confirm(`Are you sure you want to delete <strong>${fullName}</strong>?`, { loader: true, html: true })
        .then(dialog => this.remove(item.id).then(() => {
          this.fetch().then(() => dialog.close());
        }))
        .catch(() => {})
      ;
    },
  },
  created() {
    this.fetch(this.query);
  },
};
</script>
<template>
  <div class="box">
    <div class="d-flex justify-content-between mb-3">
      <h2>Administrators</h2>
      <div class="actions">
        <router-link :to="{ name: 'administrators-create' }" class="btn btn-primary">
          New Administrator
        </router-link>
      </div>
    </div>
    <table>
      <caption>
        <Pagination :pagination="pagination" :type="'administrators'" v-model="page"></Pagination>
      </caption>
      <thead>
        <tr>
          <th>Full Name</th>
          <th>EMail</th>
          <th class="w-25">Actions</th>
        </tr>
      </thead>
      <tbody>
      <tr v-if="isLoading">
        <td colspan="8" class="text-center">
          <font-awesome-icon icon="spinner" size="3x" spin class="mt-3 mb-3" />
        </td>
      </tr>
      <tr v-else-if="items.length < 1">
        <td colspan="8" class="text-center">
          There are no administrators
        </td>
      </tr>
      <tr v-else v-for="(item, index) in items" :key="item.id" :class="{ primary: index % 2 === 0 }">
        <td>{{ item.first_name }} {{ item.last_name }}</td>
        <td>{{ item.email }}</td>
        <td class="w-25">
          <router-link :to="{ name: 'administrators-edit', params: { id: item.id } }" class="mr-3">
            <font-awesome-icon icon="pencil-alt" />
          </router-link>
          <a @click="confirmDelete(item)" class="pointer text-danger">
            <font-awesome-icon icon="trash" />
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
